module.exports = "/packs/images/pages/venues/gym_mobile~eb946b07669eeaf6a3b1a2018fe0d149.jpg";